import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {threadArchiveError, threadArchiveSuccess} from "features/modals/thread-archive/reducer";

export function* archiveThreadSaga({payload}) {
    try {
        yield call([api, api.archiveThreadApi], payload);
        yield put(threadArchiveSuccess({id: payload}));
    } catch (e) {
        yield put(threadArchiveError(getErrorFromMessage(e)))
    }
}